import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

/**
 * DateFormatPipe
 * Takes a date string as an argument that is then converted to the
 * provided moment.js date format.
 *
 * Usage: date | dateFormat:format
 * Example:
 *  {{ '2013-02-08' | dateFormat:'MMMM Do YYYY' }}
 *  formats to February 8th 2013
 */

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(date: string, format: string) {
    const dateToFormat = !!(+date) ? parseInt(date) : date;
    return moment(dateToFormat).format(format);
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/date-format.pipe.ts